import { AuthContext } from '@app/providers';
import { useLocation, USER_ACCT_TYPE_EDUCATOR, USER_ACCT_TYPE_STUDENT } from '@app/utils';
import React, { useContext, useState } from 'react';
import Toast from '../toast';


export default function SSOLogin(){
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  var base64 = require('base-64');
  const { setUserInfo } = useContext(AuthContext);
  const { navigate } = useLocation();
  const params = new URLSearchParams(window.location.search);
  let paramsStr = params.get('params');
  const userData = paramsStr ? base64.decode(paramsStr) : '';
  const user = userData ? JSON.parse(userData) : null;
  
  if(user){
    if(user._responseStatus){
      localStorage.setItem("userData", userData);
      localStorage.setItem("first", JSON.stringify(user.userJson.firstName))
      localStorage.setItem("last", JSON.stringify(user.userJson.lastName))
      setUserInfo(user);
      if(user.userJson.userType === USER_ACCT_TYPE_STUDENT){
        navigate('/create-avatar');
      }
      else if(user.userJson.userType === USER_ACCT_TYPE_EDUCATOR){
        navigate('/educator')
      }
      else{
        navigate('/page-not-found')
      }
    }
    else{
      localStorage.setItem('error',user.msg)
      navigate('/sign-in')
    }
  }
  
  return (
      <Toast
      message={toastMessage.message}
      showToast={showToast}
      type={toastMessage.type}
      onClose={() => setShowToast(false)}
    />
    
  );
}

